import { FC, useMemo } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';
import Private from './private';
import Public from './public';

const Page: FC = () => {
  const { isAuth } = useAuthStore();

  const routes = useMemo(() => {
    if (isAuth) {
      return <Private />;
    }

    return <Public />;
  }, [isAuth]);

  return <Router>{routes}</Router>;
};

export default Page;
